var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.02539C0 3.60711 3.58172 0.0253906 8 0.0253906H36C40.4183 0.0253906 44 3.60711 44 8.02539V36.0254C44 40.4437 40.4183 44.0254 36 44.0254H8C3.58172 44.0254 0 40.4437 0 36.0254V8.02539Z",
    fill: "#516F90"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_11385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 27.428H25.5235V26.3005H18.5V27.428ZM18.5 23.4347H25.5V22.3072H18.5V23.4347ZM17.0201 30.9515C16.4449 30.9515 15.9645 30.7585 15.5788 30.3727C15.1929 29.987 15 29.5065 15 28.9313V15.1193C15 14.5442 15.1929 14.0638 15.5788 13.6779C15.9645 13.2921 16.4449 13.0991 17.0201 13.0991H24.2081L29 17.8676V28.9313C29 29.5065 28.8071 29.987 28.4212 30.3727C28.0353 30.7585 27.5549 30.9515 26.9799 30.9515H17.0201ZM23.5973 18.5018V14.3676H17.0201C16.8322 14.3676 16.66 14.4459 16.5034 14.6025C16.3468 14.7591 16.2685 14.9313 16.2685 15.1193V28.9313C16.2685 29.1193 16.3468 29.2915 16.5034 29.4481C16.66 29.6047 16.8322 29.683 17.0201 29.683H26.9799C27.1678 29.683 27.34 29.6047 27.4966 29.4481C27.6532 29.2915 27.7315 29.1193 27.7315 28.9313V18.5018H23.5973Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_11385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13.0254)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportactive);
export default __webpack_public_path__ + "static/media/reportactive.e74d83f985c360694528046dd614dfda.svg";
export { ForwardRef as ReactComponent };